<script>
import { markRaw } from 'vue';

import MixinList from '@/Libs/Mixins/ListTab.js';
import BranchFormSidebar from '../Part/BranchFormSidebar.vue';

export default {
    mixins: [MixinList],
    props: {
        store: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            branchFormSidebar: markRaw(BranchFormSidebar),

            routeName: 'store-detail',
            reservation: [],
        };
    },
    mounted() {
        var vm = this;

        vm.loadReservation();
    },
    methods: {
        _beforeSearch(search) {
            var vm = this;

            search.store_id = vm.$route.params.id;
            search.order_by = 'name';
            search.sort_by = 'asc';

            return search;
        },
        async _search(search) {
            return await this.$api.Branch.all(search);
        },
        async loadReservation() {
            var vm = this;

            vm.$loading.on('store_summary_reservation_create');

            try {
                var date = new Date();
                var range = vm.$dateFormat.iso(date);

                var params = {
                    store_id: vm.$route.params.id,
                    status: 'pending,approved,going',
                    order_by: 'booked',
                    sort_by: 'desc',
                    date_from: range,
                    date_to: range
                };

                var resp = await vm.$api.Reservation.all(params);

                var data = resp.data.data;

                vm.reservation = data;

                vm.$loading.off('store_summary_reservation_create');
            } catch (err) {
                // console.log(err.response.data.message) 
            }
        },
        onRefreshBranch() {
            var vm = this;

            vm.$ac.refresh();
            vm._doSearch();
        }
    }
};
</script>

<template>
    <BRow>
        <BCol xxl="3">

            <BCard no-body>
                <BCardBody>
                    <h5 class="card-title mb-3">{{ $t('store.label.activity') }}</h5>
                    <loading :loading="$loading.get('store_summary_reservation_create')" variant="dark" type="block">
                        <simplebar data-simplebar style="max-height: 500px;">
                            <div class="table-responsive">
                                <BListGroup tag="ul" class="mb-1">
                                    <BListGroupItem tag="li" v-for="(tr, index) in reservation" :key="index" :class="{
                                        'bg-warning-subtle': tr.status_name == 'pending',
                                        'bg-success-subtle': tr.status_name == 'approved',
                                        'bg-info-subtle': tr.status_name == 'going',
                                    }" @click="$router.push({ name: 'reservation-detail', params: { id: tr.id } })"
                                        class="cursor-pointer">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-grow-1">
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0 avatar-sm">
                                                        <div class="avatar-title rounded text-light" :class="{
                                                            'bg-warning': tr.status_name == 'pending',
                                                            'bg-success': tr.status_name == 'approved',
                                                            'bg-info': tr.status_name == 'going',
                                                        }">
                                                            <i class="mdi mdi-handshake-outline fs-4"
                                                                v-if="tr.status_name == 'pending'"></i>
                                                            <i class="mdi mdi-check-bold fs-4"
                                                                v-if="tr.status_name == 'approved'"></i>
                                                            <i class="mdi mdi-login fs-4"
                                                                v-if="tr.status_name == 'going'"></i>
                                                        </div>
                                                    </div>
                                                    <div class="flex-shrink-0 ms-3 d-flex flex-column">
                                                        <h6 class="fs-md mb-0">{{ tr.branch }}</h6>
                                                        <small class="text-muted">{{ tr.user }}</small>
                                                        <small>{{ $dateFormat.datetime(tr.booked_at) }}</small>
                                                        <BBadge variant="warning" v-if="tr.status_name == 'pending'">{{
                                                            tr.status }}</BBadge>
                                                        <BBadge variant="success"
                                                            v-else-if="tr.status_name == 'approved'">
                                                            {{
                                                                tr.status }}</BBadge>
                                                        <BBadge variant="info" v-else-if="tr.status_name == 'going'">{{
                                                            tr.status }}</BBadge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </BListGroupItem>
                                </BListGroup>
                            </div>
                        </simplebar>
                    </loading>
                </BCardBody>
                <BCardFooter class="text-center"
                    v-if="$ac.hasAccess('reservation_full_access') || $ac.hasAccess('reservation_list')">
                    <router-link :to="{ name: 'reservation', query: { store_id: store.id } }">{{
                        $t('basic.btn.more') }}</router-link>
                </BCardFooter>
            </BCard>
        </BCol>
        <BCol xxl="9">
            <BRow class="g-4 mb-3">
                <BCol sm="auto">
                    <div class="d-flex flex-wrap align-items-start gap-2">
                        <btn-sidebar variant="success"
                            v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_create') && $ac.hasAccessStore(store.id))"
                            :sidebar="branchFormSidebar" :data="{ store: store }"
                            :success="onRefreshBranch">
                            <i class="mdi mdi-plus-thick me-2"></i> {{ $t('store.label.branch') }}
                        </btn-sidebar>
                        <BButton type="button" variant="info"
                            @click="$router.push({ name: 'branch', query: { store_id: store.id } })"
                            v-if="$ac.hasAccess('branch_full_access') || $ac.hasAccess('branch_list')">
                            <i class="mdi mdi-format-list-text me-2"></i> {{ $t('basic.btn.more') }}
                        </BButton>
                    </div>
                </BCol>
                <BCol sm>
                    <b-form @submit="doSearch()">
                        <div class="d-flex justify-content-sm-end">
                            <div class="search-box ms-2">
                                <input type="text" class="form-control" :placeholder="$t('filter.placeholder.keyword')"
                                    v-model="search.keyword" />
                                <i class="mdi mdi-magnify search-icon"></i>
                            </div>
                        </div>
                    </b-form>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <div class="table-responsive">
                        <loading :loading="$loading.get([routeName, tabName, 'list'].join('_'))" variant="dark"
                            type="block">
                            <BListGroup tag="ul" class="mb-1">
                                <BListGroupItem tag="li" v-for="(tr, index) in list" :key="index" @click="($ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_show') && ($ac.hasAccessStore(tr.store_id) || $ac.hasAccessBranch(tr.id)))) &&
                                    $router.push({ name: 'branch-detail', params: { id: tr.id } })" :class="[$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_show') && ($ac.hasAccessStore(tr.store_id) || $ac.hasAccessBranch(tr.id))) ? 'cursor-pointer' : ''
                                    ]">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center flex-grow-1">
                                            <div class="flex-shrink-0 avatar-sm">
                                                <div class="avatar-title rounded text-dark bg-light">
                                                    <i class="mdi mdi-factory fs-2"></i>
                                                </div>
                                            </div>
                                            <div class="ms-3">
                                                <h6 class="mb-0">{{ tr.name }}</h6>
                                                <small class="text-muted d-block">{{ tr.ref_no }}</small>
                                                <small class="d-block">{{ tr.address }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </BListGroupItem>
                            </BListGroup>
                        </loading>
                    </div>

                </BCol>
            </BRow>
            <BRow class="g-0 justify-content-end mb-4" id="pagination-element">
                <BCol sm="6">
                    <pagination v-bind:model="paginator" v-on:goto="goto"
                        :disabled="$loading.get([routeName, 'list'].join('_'))" />
                </BCol>
            </BRow>
        </BCol>
    </BRow>
</template>